import Service from '@/services/Service'

class LineBusinessService extends Service {
  constructor() {
    super('LINEBUSINESS')
    this.resource = 'line-business'
  }

  translateToFirebird(obj) {
    let objFirebird = {
      NOME: obj.nome,
    }

    return objFirebird
  }

  translateFromFirebird(payload) {
    let objeto = {
      nome: payload.NOME,
    }
    return objeto
  }

  async getLineBusiness(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    let data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }

  async getLinesBusiness() {
    return await this.getAPI(this.resource)
  }
}

export default new LineBusinessService()
